import { render } from "./url.vue?vue&type=template&id=0f084ff7&lang=pug"
import script from "./url.vue?vue&type=script&setup=true&lang=js"
export * from "./url.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__